import { render, staticRenderFns } from "./VenuPage.vue?vue&type=template&id=a257dbd4&"
import script from "./VenuPage.vue?vue&type=script&lang=js&"
export * from "./VenuPage.vue?vue&type=script&lang=js&"
import style0 from "./VenuPage.vue?vue&type=style&index=0&id=a257dbd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports